/* FB | Urun Vitrini yardimcisi. ADDITIVE, calisan yapiyi bozmaz.
   0) HIZ: hover=none kartlarda kullanilmayan secondary gorselleri kaldir (yavas baglantida iptal eder).
   1) Ana sayfa vitrini: 2 ESKI + 1 YENI (son 7 gun) deseni; her yenilemede HER IKI grup yeniden karisir.
   2) Koleksiyon/urun vitrini: stogu bitenleri (.fps-oos) en alta sirala.
   3) PC marquee hizini urun sayisindan BAGIMSIZ sabit px/sn'ye sabitle. SADECE PC. */
(function () {
  if (window.__fbVitrinShuffle) return;
  window.__fbVitrinShuffle = true;

  function getCards(wrapper) {
    var cards = [], kids = wrapper.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.classList && el.classList.contains('fps-card') && !el.classList.contains('fps-clone')) cards.push(el);
    }
    return cards;
  }

  function dropUnusedSecondary(scope) {
    try {
      var secs = (scope || document).querySelectorAll('.fps-card__img--secondary');
      for (var i = 0; i < secs.length; i++) {
        var im = secs[i];
        var wrap = im.closest ? im.closest('.fps-card__img-wrap') : null;
        if (wrap && wrap.classList.contains('fps-h--none')) {
          try { im.removeAttribute('srcset'); im.removeAttribute('src'); if (im.parentNode) im.parentNode.removeChild(im); } catch (e) {}
        }
      }
    } catch (e) {}
  }

  function shuffleWrapper(wrapper) {
    if (!wrapper) return;
    if (wrapper.dataset.fbShuffled === '1') return;
    if (wrapper.dataset.fpsMarquee === '1') return;
    if (wrapper.querySelector('.fps-card.fps-clone')) return;
    var cards = getCards(wrapper);
    if (cards.length < 2) { wrapper.dataset.fbShuffled = '1'; return; }
    /* FB v3 (kullanici istegi): 7'li DESEN -> 2 eski, 1 yeni, 2 eski, 1 KOLYE, 1 KIYAFET; tekrar eder.
       eski/yeni = KIYAFET (aksesuar haric) urunun data-fps-created tarihine gore (son 7 gun = yeni).
       KOLYE/aksesuar = urun basligindan tespit (kolye, kupe, canta vb. = aksesuar; gerisi kiyafet).
       Her sayfa yuklenisinde gruplar yeniden karisir -> her yenilemede farkli. Salt istemci-tarafi. */
    var WEEK = 7 * 24 * 60 * 60;
    var nowSec = Math.floor(Date.now() / 1000);
    function fbNorm(s) { return (s || '').toLowerCase().replace(/ç/g, 'c').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ı/g, 'i').replace(/İ/g, 'i').replace(/â/g, 'a'); }
    var FB_ACC = ['kolye', 'kupe', 'bileklik', 'yuzuk', 'halhal', 'canta', 'cuzdan', 'fular', 'esarp', 'aksesuar', 'gozluk', 'anahtarlik', 'bros'];
    function fbTitle(c) { var t = c.querySelector('.fps-card__name'); return fbNorm(t ? t.textContent : ''); }
    function fbIsAcc(c) { var t = fbTitle(c); for (var i = 0; i < FB_ACC.length; i++) { if (t.indexOf(FB_ACC[i]) > -1) return true; } return false; }
    function fbIsNeck(c) { return fbTitle(c).indexOf('kolye') > -1; }
    function fbIsNew(c) { var ts = parseInt(c.getAttribute('data-fps-created') || '', 10); return !isNaN(ts) && ts > 0 && (nowSec - ts) <= WEEK; }
    /* FB (kullanici istegi 2026-06-20): TUM urunler (kiyafet + taki + canta) HER YUKLEMEDE tamamen karisik gosterilir.
       Basit Fisher-Yates; kategori/desen yok -> hicbir kosulda hata vermez. Urun eklensin/eklenmesin omur boyu kusursuz. */
    for (var sx = cards.length - 1; sx > 0; sx--) {
      var sy = Math.floor(Math.random() * (sx + 1));
      var sz = cards[sx]; cards[sx] = cards[sy]; cards[sy] = sz;
    }
    for (var m = 0; m < cards.length; m++) wrapper.appendChild(cards[m]);
    wrapper.dataset.fbShuffled = '1';
  }

  function moveOosBottom(wrapper) {
    if (!wrapper) return;
    if (wrapper.querySelector('.fps-card.fps-clone')) return;
    var cards = getCards(wrapper);
    if (cards.length < 2) return;
    var seenOos = false, needs = false, oos = [];
    for (var i = 0; i < cards.length; i++) {
      var isOos = !!cards[i].querySelector('.fps-oos');
      if (isOos) { seenOos = true; oos.push(cards[i]); }
      else if (seenOos) { needs = true; }
    }
    if (!needs || !oos.length) return;
    for (var k = 0; k < oos.length; k++) wrapper.appendChild(oos[k]);
  }

  function isUrunVitrini(w) { return !!(w.closest && w.closest('[id*="fb_urun_vitrini"]')); }

  function runVitrin() {
    dropUnusedSecondary(document);
    var wraps = document.querySelectorAll('.fps-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (isUrunVitrini(w)) { moveOosBottom(w); } else { shuffleWrapper(w); }
    }
  }

  function watchOos() {
    var wraps = document.querySelectorAll('[id*="fb_urun_vitrini"] .fps-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      (function (w) {
        if (w.__fbOosWatch) return; w.__fbOosWatch = true;
        try {
          var t;
          var ob = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { moveOosBottom(w); }, 120); });
          ob.observe(w, { childList: true });
        } catch (e) {}
      })(wraps[i]);
    }
  }

  var SPEED_PX_PER_SEC = 60;
  function applySpeedOne(w) {
    if (!w) return;
    if (window.innerWidth < 750) return;
    var d = parseFloat(getComputedStyle(w).getPropertyValue('--fps-marquee-distance')) || 0;
    if (d <= 0) return;
    var target = Math.max(20, Math.round(d / SPEED_PX_PER_SEC)) + 's';
    var cur = (w.style.getPropertyValue('--fps-marquee-duration') || '').trim();
    if (cur === target) return;
    w.style.setProperty('--fps-marquee-duration', target);
  }
  function applySpeedAll() {
    var wraps = document.querySelectorAll('.fps-marquee-mode .fps-wrapper');
    for (var i = 0; i < wraps.length; i++) applySpeedOne(wraps[i]);
  }
  function hookSpeed() {
    var wraps = document.querySelectorAll('.fps-marquee-mode .fps-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.__fbSpeedHooked) continue;
      w.__fbSpeedHooked = true;
      try {
        var obs = new MutationObserver(function (muts) { for (var n = 0; n < muts.length; n++) applySpeedOne(muts[n].target); });
        obs.observe(w, { attributes: true, attributeFilter: ['style', 'class'] });
      } catch (e) {}
    }
    applySpeedAll();
  }

  function init() {
    dropUnusedSecondary(document);
    runVitrin(); watchOos();
    hookSpeed();
    setTimeout(applySpeedAll, 450); setTimeout(applySpeedAll, 1000); setTimeout(applySpeedAll, 1800);
    setTimeout(function () { dropUnusedSecondary(document); runVitrin(); watchOos(); }, 500);
    setTimeout(function () { dropUnusedSecondary(document); runVitrin(); watchOos(); }, 1200);
  }
  if (document.querySelector('.fps-wrapper')) init();
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(applySpeedAll, 400); });
  window.addEventListener('pageshow', function () { setTimeout(applySpeedAll, 250); });
})();